import type { ReactNode } from 'react';
import { notification } from '@/uicomponents';
import { NotificationIcon } from '@/components/shared';

interface IShowNotification {
  message: string | ReactNode;
  messageHeader?: string;
  type?: 'error' | 'success';
  placement?: 'bottom' | 'top' | 'topRight';
  duration?: number;
  // A stable key makes a new toast REPLACE a prior one with the same key
  // (antd dedupes by key) instead of stacking — avoids misleading overlap.
  key?: string;
}

export const showNotification = ({
  message,
  messageHeader,
  type = 'success',
  placement = 'topRight',
  duration,
  key,
}: IShowNotification) => {
  notification[type]({
    title: messageHeader ? messageHeader : message,
    description: messageHeader ? message : null,
    placement,
    icon: <NotificationIcon variant={type} />,
    duration,
    key,
  });
};
